import * as Yup from 'yup'

export const setupValidationSchema = () => {
  return (
    Yup.object().shape({
      total_additional_assets: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for total additional assets is required')
        .min(0, `You can't have a negative asset value`),
      total_from_selected_assets: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for total selected assets is required')
        .min(0, `You can't have a negative asset value`),
      total_existing_life_cover: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for total existing life cover is required')
        .min(0, `You can't have a negative life cover value`),
      total_additional_liabilities: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for total additional liabilities is required')
        .min(0, `You can't have a negative liability value`),
      total_from_selected_liabilities: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for total selected liabilities is required')
        .min(0, `You can't have a negative liability value`),
      dependents: Yup.array()
        .of(
          Yup.object().shape({
            name: Yup.string('There seems to be some unsupported symbols in the name')
              .typeError('There seems to be some unsupported symbols in the name')
              .required('You need to provide a name for your dependent'),
            value: Yup.number('The monthly income should be a number')
              .typeError('The monthly income should be a number')
              .required('You need to provide a monthly value for your dependent')
              .min(0, `You can't have a negative value for the dependent`),
            time_horizon: Yup.number('The number of years should be a number')
              .typeError('The number of years should be a number')
              .required(`You need to specify a number of years`)
              .min(0, `You can't have a negative number of years`)
              .max(100, 'Number of years has to be <100')
          })
        )
    })
  )
}
